export const DocumentTypes = {
  email: "Email",
  sms: "Sms",
  whatsapp: "Whatsapp",
  push: "Push",
};
